module.exports = __webpack_public_path__ + "img/2026-10-11a_3.f3676ec6.jpg";